import { FC } from 'react'
import dynamic from 'next/dynamic'
import { Row, Col, Text, Breadcrumb } from '@/client/components'
import artworkAssistantLottie2 from './Lottie/artworkAssistantLottie2.json'
import * as S from './styles'
import { FeaturedProps } from '../types'

// Load Lottie-Component only in case of client side rendering (exclude SSR)
const Lottie = dynamic(() => import('lottie-react'), { ssr: false })

export const Featured: FC<FeaturedProps> = ({ breadcrumb, title, subtitle, description }) => {
  const directions = [
    { dir: 'column', mq: 'xs' },
    { dir: 'row', mq: 'xl' }
  ]

  return (
    <>
      <S.Featured>
        <Row>
          <Col>
            <Breadcrumb pages={breadcrumb} />
          </Col>
        </Row>
        <Row directions={directions}>
          <Col style={{ alignContent: 'center' }}>
            <S.LeftFeatured>
              <Text as='h2' color='primary' family='heading'>
                {subtitle}
              </Text>
              <Text as='h1' size='xxlg' family='heading' weight='bold' margin='0 0 2.5rem' itemProp='name'>
                {title}
              </Text>
              <Text color='weak' margin='0 0 2rem' itemProp='description'>
                {description}
              </Text>
            </S.LeftFeatured>
          </Col>
          <Col style={{ textAlign: '-webkit-center' }}>
            <S.LottieFeatured>
              <Lottie animationData={artworkAssistantLottie2} loop={true} />
            </S.LottieFeatured>
          </Col>
        </Row>
      </S.Featured>
    </>
  )
}
